import React, { useEffect, useState } from "react";
import axios from "axios";
import "./po.css";
//const { REACT_APP_FROM, REACT_APP_DB, REACT_APP_PORT_BACK } = process.env;
import { useNavigate, useLocation } from "react-router-dom";

const Po = () => {
  const { REACT_APP_DB, REACT_APP_PORT_BACK, REACT_APP_FROM } = process.env;

  // =========================================================
  // USER / SUPPLIER
  // =========================================================
  const location = useLocation();

  const username = location.state?.idvender;

  const fullname = location.state?.fullname || "Usffer";

  const userinuse = location.state?.userinuse;

  console.log("username", username);
  console.log("fullname", fullname);
  console.log("userinusefrmpo_", userinuse);

  // =========================================================
  // MATCO VENDER ID
  // =========================================================
  const [selectedvenderid, setSelectedvenderid] = useState("");

  const [dataListVenderid, setListVenderid] = useState([]);

  // =========================================================
  // PO LIST
  // =========================================================
  const [poList, setPoList] = useState([]);

  // =========================================================
  // PART LIST
  // =========================================================
  const [expandedPO, setExpandedPO] = useState(null);

  const [partList, setPartList] = useState({});

  const [loadingPart, setLoadingPart] = useState(null);

  // =========================================================
  // PDF PREVIEW
  // =========================================================
  const [previewUrl, setPreviewUrl] = useState(null);

  const [previewItem, setPreviewItem] = useState(null);

  // =========================================================
  // CONFIRMATION
  // =========================================================
  const [selectedPO, setSelectedPO] = useState(null);

  const [showResponseDialog, setShowResponseDialog] = useState(false);

  const [status, setStatus] = useState("Confirmed");

  const [issueDetail, setIssueDetail] = useState("");

  const [attachment, setAttachment] = useState(null);

  const [isSubmitting, setIsSubmitting] = useState(false);

  // =========================================================
  // REPLY HISTORY
  // =========================================================
  const [showHistory, setShowHistory] = useState(false);

  const [historyItem, setHistoryItem] = useState(null);

  const [historyList, setHistoryList] = useState([]);

  const [loadingHistory, setLoadingHistory] = useState(false);

  // =========================================================
  // FETCH PO
  // =========================================================

  const fetchList = async (venderid = null) => {
    console.log("fetchList:", selectedvenderid);

    const userstr = venderid || username; // ✅ ใช้บรรทัดนี้พอ
    console.log("userstr_", userstr.split("|")[0]);
    try {
      const url =
        REACT_APP_FROM === "local"
          ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/po/listpo`
          : `/api/po/listpo`;

      const res = await axios.post(url, {
        userid: userstr.split("|")[0],
        // venderid: venderid, // 👈 ส่งเพิ่มไป
      });

      setPoList(res.data);
      console.log("polist_", res.data);
    } catch (err) {
      console.error("Error loading list", err);
    }
  };

  useEffect(() => {
    if (fullname?.toLowerCase() === "matco") {
      // ถ้าเป็น matco ต้องเลือก vender ก่อน
      if (selectedvenderid) {
        fetchList(selectedvenderid);
      }
    } else {
      // supplier ปกติ โหลดเลย
      fetchList();
    }
  }, [selectedvenderid, fullname]);

  // =========================================================
  // FETCH VENDER ID LIST
  // =========================================================
  // ดึงข้อมูล venderid จาก API
  useEffect(() => {
    const fetchvenderid = async () => {
      try {
        const url =
          REACT_APP_FROM === "local"
            ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/showidvender`
            : `/api/showidvender`;
        const response = await fetch(url);
        const data = await response.json();
        console.log(data + "_test");
        setListVenderid(data);
      } catch (error) {
        console.error("Error fetching buyers:", error);
      }
    };
    fetchvenderid();
  }, []);

  // =========================================================
  // BACKEND URL
  // =========================================================
  const BACKEND_URL =
    REACT_APP_FROM === "local"
      ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}`
      : "";

  // =========================================================
  // LOAD PO LIST
  // =========================================================
  useEffect(() => {
    loadPOList();
  }, []);

  const loadPOList = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/po`);

      if (!response.ok) {
        throw new Error("Cannot load PO list");
      }

      const data = await response.json();

      setPoList(data);
    } catch (error) {
      console.error("Load PO error:", error);
    }
  };

  // =========================================================
  // EXPAND / COLLAPSE PO
  // =========================================================
  const togglePO = async (po) => {
    if (expandedPO === po.PurchOrderId) {
      setExpandedPO(null);
      return;
    }

    setExpandedPO(po.PurchOrderId);

    // ถ้าเคยโหลดแล้วไม่ต้องโหลดซ้ำ
    if (partList[po.PurchOrderId]) {
      return;
    }

    await loadPartList(po.PurchOrderId);
  };

  // =========================================================
  // LOAD PART LIST
  // =========================================================
  const loadPartList = async (PurchOrderId) => {
    console.log("PurchOrderId_", PurchOrderId);
    try {
      setLoadingPart(PurchOrderId);

      const response = await fetch(
        `${BACKEND_URL}/api/po/${PurchOrderId}/poi_listitem`,
      );
      //   const url =
      //     REACT_APP_FROM === "local"
      //       ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/po/${PurchOrderId}/poi_listitem`
      //       : `/api/po/${PurchOrderId}/poi_listitem`;
      //   const response = await fetch(url);

      if (!response.ok) {
        throw new Error("Cannot load part list");
      }

      const data = await response.json();

      setPartList((prev) => ({
        ...prev,
        [PurchOrderId]: data,
      }));
    } catch (error) {
      console.error("Load Part error:", error);
    } finally {
      setLoadingPart(null);
    }
  };

  // =========================================================
  // PDF PREVIEW
  // =========================================================
  const openPDF = (po) => {
    console.log("PDFFileName_", po.PdfStoredPath);
    if (!po.PdfStoredPath) return;

    const url =
      REACT_APP_FROM === "local"
        ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/po-fileslocal/${po.PdfStoredPath}`
        : `/api/po-fileslinux/${po.PdfStoredPath}`;

    setPreviewUrl(url);
    setPreviewItem(po);
  };

  // =========================================================
  // EXCEL
  // =========================================================
  const openExcel = (po) => {
    if (!po.ExcelStoredPath) return;

    const excelUrl =
      REACT_APP_FROM === "local"
        ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/po-excellocal/${po.ExcelStoredPath}`
        : `/api/po-excellinux/${po.ExcelStoredPath}`;

    window.open(excelUrl, "_blank");
  };

  // =========================================================
  // TXT
  // =========================================================
  const openTextFile = (po) => {
    if (!po.TxtStoredPath) return;

    const textUrl =
      REACT_APP_FROM === "local"
        ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/po-txtlocal/${po.TxtStoredPath}`
        : `/api/po-txtlinux/${po.TxtStoredPath}`;

    window.open(textUrl, "_blank");
  };

  // =========================================================
  // OPEN CONFIRMATION
  // =========================================================
  const openConfirmation = (po) => {
    setSelectedPO(po);

    setStatus("Confirmed");
    setIssueDetail("");
    setAttachment(null);

    setShowResponseDialog(true);

    // ปิด PDF Preview
    setPreviewUrl(null);
  };

  // =========================================================
  // SUBMIT CONFIRMATION
  // =========================================================

  const handleSubmit = async () => {
    if (!selectedPO) return;

    console.log("PurchOrderLoadId_", selectedPO.PurchOrderLoadId);

    try {
      const form = new FormData();

      form.append("PoID", selectedPO.PurchOrderLoadId);
      form.append("PurchOrderId", selectedPO.PurchOrderId);
      form.append("VendorCode", username);
      form.append("VendorName", fullname);
      form.append("ResponseStatus", status);
      form.append("IssueDetail", issueDetail || "");
      form.append("Userinuse", userinuse);

      if (attachment) {
        form.append("Attachment", attachment);
      }

      const url =
        REACT_APP_FROM === "local"
          ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/po/submitPOresponse`
          : `/api/po/submitPOresponse`;

      const res = await axios.post(url, form);

      console.log("dataconfirmPO_", res.data);

      if (res.data.dbSuccess && res.data.emailSuccess) {
        alert("บันทึกสำเร็จ และส่งอีเมลเรียบร้อย");

        // Reset form เฉพาะเมื่อบันทึกและส่งอีเมลสำเร็จ
        setShowResponseDialog(false);
        setSelectedPO(null);
        setStatus("Confirmed");
        setIssueDetail("");
        setAttachment(null);

        // Refresh PO
        // await loadPOList();
        await fetchList();
      } else if (res.data.dbSuccess && !res.data.emailSuccess) {
        alert(
          `บันทึกข้อมูลสำเร็จ แต่ส่ง e-mail ไม่สำเร็จ กรุณาติดต่อ IT Matco\n` +
            `พบ email ผิด:\n${(res.data.invalidEmails || []).join("\n")}`,
        );
      } else {
        alert("ไม่สามารถบันทึกข้อมูลได้");
      }
    } catch (error) {
      console.error("Submit PO error:", error.response?.data || error.message);

      alert("เกิดข้อผิดพลาด ไม่สามารถส่งข้อมูลได้");
    }
  };

  // =========================================================
  // LOAD REPLY HISTORY
  // =========================================================
  const loadHistory = async (po) => {
    console.log("poloadHistory_", po);
    try {
      setHistoryItem(po);
      setShowHistory(true);
      setLoadingHistory(true);
      setHistoryList([]);

      const url =
        REACT_APP_FROM === "local"
          ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/po/response/history/${po.PurchOrderLoadId}`
          : `/api/po/response/history/${po.PurchOrderLoadId}`;

      const res = await axios.get(url);
      console.log("{ResponseID_}", res.data);
      setHistoryList(res.data);
      setHistoryItem(po);
      console.log("{loadHistorypo_}", po);
      setShowHistory(true);
    } catch (err) {
      console.error("load history error", err);
    }
  };

  // =========================================================
  // FORMAT DATE
  // =========================================================
  const formatDate = (date) => {
    if (!date) return "-";

    return date.replace("T", " ").replace("Z", "");
  };

  return (
    <div className="forecast-container">
      {/* =====================================================
          HEADER
      ===================================================== */}
      <nav className="navbar">
        <div>
          <h1>PO Confirmation</h1>
          <h2>Supplier: {fullname}</h2>
        </div>
      </nav>
      {fullname?.toLowerCase() === "matco" && (
        <div style={{ margin: "15px 0" }}>
          <label style={{ marginRight: "10px" }}>Select venderID:</label>

          <input
            list="vender-name-list"
            value={selectedvenderid}
            onChange={(e) => setSelectedvenderid(e.target.value)}
            onFocus={() => setSelectedvenderid("")}
            placeholder="Type or select a venderid"
          />

          <datalist id="vender-name-list">
            {dataListVenderid.map((item, index) => (
              <option key={index} value={item.VenderID} />
            ))}
          </datalist>
        </div>
      )}
      {/* =====================================================
          PO TABLE
      ===================================================== */}
      <table className="forecast-table">
        <thead>
          <tr>
            <th style={{ width: "60px" }}></th>

            <th>PO Number</th>
            {/* 
            <th>PO Date</th>

            <th>Total Part</th> */}

            <th>Download Attachment</th>

            <th>Supplier Confirmation</th>

            <th>Supplier Response</th>

            <th>Remark</th>
          </tr>
        </thead>

        <tbody>
          {poList.length === 0 ? (
            <tr>
              <td colSpan="8" className="text-center">
                No PO data
              </td>
            </tr>
          ) : (
            poList.map((po) => (
              <React.Fragment key={po.PurchOrderId}>
                {/* =================================================
                 PO MAIN ROW
                  ================================================= */}
                <tr>
                  {/* + / - */}
                  <td className="text-center">
                    <button className="expand-btn" onClick={() => togglePO(po)}>
                      {expandedPO === po.PurchOrderId ? "−" : "+"}
                    </button>
                  </td>

                  {/* PO Number */}
                  <td className="text-center">{po.PurchOrderId}</td>

                  {/* PO Date */}
                  {/* <td className="text-center">{po.PoDate || "-"}</td> */}

                  {/* Total Part */}
                  {/* <td className="text-center">{po.TotalPart || "-"}</td> */}

                  {/* =================================================
                  DOWNLOAD ATTACHMENT
                    ================================================= */}
                  <td>
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        justifyContent: "center",
                      }}
                    >
                      {/* PDF */}
                      {po.PdfStoredPath && (
                        <button
                          className="preview-btn"
                          onClick={() => openPDF(po)}
                        >
                          PDF
                        </button>
                      )}

                      {/* Excel */}
                      {po.ExcelStoredPath && (
                        <button
                          className="confirm-btn"
                          onClick={() => openExcel(po)}
                        >
                          Excel
                        </button>
                      )}

                      {/* TXT */}
                      {po.TxtStoredPath && (
                        <button
                          className="txt-btn"
                          onClick={() => openTextFile(po)}
                        >
                          TXT
                        </button>
                      )}
                    </div>
                  </td>

                  {/* =================================================
                      CONFIRMATION
                        ================================================= */}
                  <td className="text-center">
                    {/* <button
                      className="confirm-btn"
                      onClick={() => openConfirmation(po)}
                    >
                      Confirmation
                    </button> */}
                    <button
                      className="confirm-btn"
                      onClick={() => {
                        setPreviewItem(po);
                        setSelectedPO(po);
                        setShowResponseDialog(true);
                        setPreviewUrl(null); // ปิด preview
                      }}
                    >
                      Confirmation
                    </button>
                  </td>

                  {/* =================================================
                     RESPONSE STATUS
                     ================================================= */}
                  <td className="text-center">
                    <span
                      className={`status-badge ${
                        po.DisplayStatus === "Confirmed"
                          ? "status-success"
                          : po.DisplayStatus === "Rejected"
                            ? "status-rejected"
                            : po.DisplayStatus === "Under Review"
                              ? "status-underreview"
                              : po.DisplayStatus === "Delay Confirmation"
                                ? "status-delay"
                                : "status-pending"
                      }`}
                    >
                      {po.DisplayStatus === "Has Issue"
                        ? "Rejected"
                        : po.DisplayStatus || "Pending"}
                    </span>
                  </td>

                  {/* =================================================
                         REPLY HISTORY
                        ================================================= */}
                  <td className="text-center">
                    <button
                      className="history-btn"
                      onClick={() => loadHistory(po)}
                    >
                      Reply History
                    </button>
                  </td>
                </tr>

                {/* =================================================
            PART LIST
        ================================================= */}
                {expandedPO === po.PurchOrderId && (
                  <tr>
                    <td colSpan="8">
                      <div className="part-container">
                        <h3>Part List – PO {po.PurchOrderId}</h3>

                        {loadingPart === po.PurchOrderId ? (
                          <div className="text-center">
                            Loading Part List...
                          </div>
                        ) : !partList[po.PurchOrderId] ||
                          partList[po.PurchOrderId].length === 0 ? (
                          <div className="text-center">No Part found</div>
                        ) : (
                          <table className="part-table">
                            <thead>
                              <tr>
                                <th>NO.</th>
                                <th>PART NUMBER</th>
                                <th>PART NAME</th>
                                <th>QTY</th>
                                {/* <th>Measure</th> */}
                                <th>UNIT PRICE</th>
                                <th>AMOUNT</th>
                                <th>DEL. DATE</th>
                                {/* <th>Record ID</th> */}
                              </tr>
                            </thead>

                            <tbody>
                              {partList[po.PurchOrderId].map((part, index) => (
                                <tr key={part.POlineNbr || index}>
                                  <td className="text-center">{index + 1}</td>
                                  <td>{part.ItemID}</td>
                                  <td>{part.ItemName}</td>

                                  <td>
                                    {part.RequiredQTY} {part.Measure}
                                  </td>
                                  {/* <td>{part.Measure}</td> */}
                                  <td>{part.UnitPrice}</td>
                                  <td>{part.Amount}</td>
                                  <td>{part.TypeReport}</td>

                                  {/* 
                                  <td className="text-right">
                                    {part.POI_PurConvFactor}
                                  </td> */}

                                  {/* <td className="text-center">
                                    {part.POI_RecordID}
                                  </td> */}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))
          )}
        </tbody>
      </table>

      {/* =========================================================
          REPLY HISTORY MODAL
      ========================================================= */}
      {showHistory && historyItem && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>HISTORY Po– {historyItem.PurchOrderId}</h2>

            <button className="close-btn" onClick={() => setShowHistory(false)}>
              X
            </button>

            {/* Loading */}
            {historyList.length === 0 ? (
              <p>There are no replies</p>
            ) : (
              historyList.map((h, idx) => (
                <div className="history-item" key={h.ResponseID || idx}>
                  {/* Status */}
                  <p>
                    <b>Status:</b>{" "}
                    {h.ResponseStatus === "Has Issue"
                      ? "Rejected"
                      : h.ResponseStatus}
                  </p>

                  {/* Issue */}
                  {h.IssueDetail && (
                    <p>
                      <b>Detail:</b> {h.IssueDetail}
                    </p>
                  )}

                  {/* Date */}
                  <p>
                    <b>Date:</b> {formatDate(h.RespondedDate)}
                  </p>

                  {/* Attachment */}
                  {h.AttachmentPath && (
                    <p>
                      <a
                        href={
                          REACT_APP_FROM === "local"
                            ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/po/attachmentload/${h.ResponseID}`
                            : `/api/po/attachmentload/${h.ResponseID}`
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        ดาวน์โหลดไฟล์แนบ
                      </a>
                    </p>
                  )}

                  <hr />
                </div>
              ))
            )}
          </div>
        </div>
      )}

      {/* =========================================================
          CONFIRMATION DIALOG
      ========================================================= */}
      {showResponseDialog && selectedPO && (
        <div className="dialog-overlay">
          <div className="dialog-box">
            <button
              className="close-btn"
              onClick={() => setShowResponseDialog(false)}
            >
              X
            </button>

            <h2>PO Confirmation</h2>

            <p>
              <b>PO Number:</b> {selectedPO.PurchOrderId}
            </p>

            {/* =================================================
                  RESPONSE
              ================================================= */}
            <label className="response-label">
              Supplier Response:
              <select
                className={`response-select ${
                  status === "Confirmed"
                    ? "status-confirmed"
                    : status === "Rejected"
                      ? "status-rejected"
                      : ""
                }`}
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="Confirmed">Confirmed PO</option>

                <option value="Rejected">Rejected PO</option>
              </select>
            </label>

            {/* =================================================
                  REJECT DETAIL
              ================================================= */}
            {status === "Rejected" && (
              <>
                <label className="issue-label">
                  Report Issue:
                  <textarea
                    className="issue-textarea"
                    value={issueDetail}
                    onChange={(e) => setIssueDetail(e.target.value)}
                    placeholder="Please enter reason..."
                  />
                </label>

                <label>
                  Attach file:
                  <input
                    type="file"
                    onChange={(e) => setAttachment(e.target.files?.[0] || null)}
                  />
                </label>
              </>
            )}

            {/* =================================================
                  SUBMIT
              ================================================= */}
            <div className="dialog-actions">
              <button
                className="submit-btn"
                disabled={isSubmitting}
                onClick={async () => {
                  if (isSubmitting) return;

                  try {
                    setIsSubmitting(true);

                    await handleSubmit();
                  } finally {
                    setIsSubmitting(false);
                  }
                }}
              >
                {isSubmitting ? "Submitting..." : "Submit Response"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* =========================================================
          PDF PREVIEW
      ========================================================= */}
      {previewUrl && previewItem && (
        <div className="preview-modal">
          <div className="preview-content">
            <div className="preview-header">
              <h3>PO {previewItem.PurchOrderId}</h3>

              <button className="close-btn" onClick={() => setPreviewUrl(null)}>
                X
              </button>
            </div>

            <iframe
              src={previewUrl}
              title="PO Preview"
              width="100%"
              height="100%"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Po;
